import { createPremiumModule } from '@wix/premium-fed-sdk/@premium-module';
import { EntriBiExtension } from './extensions/entriBiExtension';
import { EntriWindowClientExtension } from './Backend';
import { startEntriFlow } from './startEntriFlow';
import { resolveEntriEligibility } from './resolveEntriEligibility';
import { waitForEntriClose } from './waitForEntriClose';
import { EntriModalsExtension } from './extensions/entriModalsExtension';
export const EntriModule = createPremiumModule('entriModule', [EntriBiExtension, EntriWindowClientExtension, EntriModalsExtension], () => ({
  SDK: {
    startEntriFlow,
    resolveEntriEligibility,
    // Resolves only once Entri dispatched `onEntriClose`, so callers can
    // safely unmount the embed container / navigate away afterwards without
    // stranding the in-flight flow.
    closeEntriFlow: async () => {
      if (!window.entri) {
        return;
      }
      const closed = waitForEntriClose();
      await window.entri.close();
      await closed;
    }
  }
}));
//# sourceMappingURL=EntriModule.js.map